"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ra_language_english_1 = __importDefault(require("ra-language-english"));
var defaultI18nProvider = function defaultI18nProvider(locale) {
  return ra_language_english_1.default;
};
exports.default = defaultI18nProvider;